export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8230.57b4dacd.jpg";